import { Widget } from 'jamespot-front-business';
import { JRCInputText } from 'jamespot-react-components';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { shallowEqual } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';

export const WidgetTitleEdit = ({ uniqid }: { uniqid: string }) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const widgetWrapperTitle = useAppSelector(
        (state) => Widget.selectors.selectWidget(state, uniqid)?.title,
        shallowEqual,
    );

    const { control, watch } = useForm({
        defaultValues: { widgetTitle: widgetWrapperTitle },
        criteriaMode: 'all',
    });

    useEffect(() => {
        const subscription = watch((data) => {
            dispatch(Widget.slice.actions.updateWidgetWrapper({ uniqid, title: data.widgetTitle }));
        });
        return () => subscription.unsubscribe();
    }, [watch, dispatch, uniqid]);

    return (
        <JRCInputText
            name={'widgetTitle'}
            control={control}
            placeholder={intl.formatMessage({ id: 'GLOBAL_Title' })}
            width="100%"
            margin="0"
        />
    );
};
